import React from 'react'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function Index16() {
  return (
    <div>
        <UserHeader/>
        <main className="main">
  <div className="intro-slider-container">
    <div className="intro-slider owl-carousel owl-simple owl-nav-inside owl-light" data-toggle="owl" data-owl-options="{&quot;nav&quot;:false, &quot;dots&quot;: false, &quot;loop&quot;: false}">
      <div className="intro-slide" style={{backgroundImage: 'url(asset/images/demos/demo-16/slider/slide-1.jpg)'}}>
        <div className="container intro-content text-center">
          <h3 className="intro-subtitle">Want to know what's hot?</h3>{/* End .h3 intro-subtitle */}
          <h1 className="intro-title text-white">For Spring In The City</h1>{/* End .intro-title */}
          <a href="#scroll-to-content" className="btn btn-outline-white scroll-to">
            <span>Start scrolling</span>
            <i className="icon-long-arrow-down" />
          </a>
        </div>{/* End .intro-content */}
      </div>{/* End .intro-slide */}
    </div>{/* End .intro-slider owl-carousel owl-simple */}
    <span className="slider-loader text-white" />{/* End .slider-loader */}
  </div>{/* End .intro-slider-container */}
  <div className="container" id="scroll-to-content">
    <div className="pt-7" />{/* End .pt-6 */}
    <div className="row">
      <div className="col-lg-3 col-sm-6">
        <div className="icon-box text-center">
          <span className="icon-box-icon text-dark">
            <i className="icon-truck" />
          </span>
          <div className="icon-box-content">
            <h3 className="icon-box-title">Payment &amp; Delivery</h3>{/* End .icon-box-title */}
            <p>Free shipping for orders over $50</p>
          </div>{/* End .icon-box-content */}
        </div>{/* End .icon-box */}
      </div>{/* End .col-lg-3 col-sm-6 */}
      <div className="col-lg-3 col-sm-6">
        <div className="icon-box text-center">
          <span className="icon-box-icon text-dark">
            <i className="icon-rotate-left" />
          </span>
          <div className="icon-box-content">
            <h3 className="icon-box-title">Return &amp; Refund</h3>{/* End .icon-box-title */}
            <p>Free 100% money back guarantee</p>
          </div>{/* End .icon-box-content */}
        </div>{/* End .icon-box */}
      </div>{/* End .col-lg-3 col-sm-6 */}
      <div className="col-lg-3 col-sm-6">
        <div className="icon-box text-center">
          <span className="icon-box-icon text-dark">
            <i className="la la-unlock" />
          </span>
          <div className="icon-box-content">
            <h3 className="icon-box-title">Secure Payment</h3>{/* End .icon-box-title */}
            <p>100% secure payment</p>
          </div>{/* End .icon-box-content */}
        </div>{/* End .icon-box */}
      </div>{/* End .col-lg-3 col-sm-6 */}
      <div className="col-lg-3 col-sm-6">
        <div className="icon-box text-center">
          <span className="icon-box-icon text-dark">
            <i className="icon-headphones" />
          </span>
          <div className="icon-box-content">
            <h3 className="icon-box-title">Quality Support</h3>{/* End .icon-box-title */}
            <p>Alway online feedback 24/7</p>
          </div>{/* End .icon-box-content */}
        </div>{/* End .icon-box */}
      </div>{/* End .col-lg-3 col-sm-6 */}
    </div>{/* End .row */}
    <hr className="mt-2 mb-6" />
    <div className="products-display">
      <div className="heading text-center">
        <h4 className="subtitle text-primary">Womens Clothing</h4>{/* End .subtitle */}
        <h2 className="title">Refresh Your Wardrobe</h2>{/* End .title */}
        <p className="title-desc">Discover this season’s latest trends with the newest additions to <br />our women’s clothing collection.</p>{/* End .title-desc */}
      </div>{/* End .heading */}
      <div className="row">
        <div className="col-lg-6">
          <div className="banner banner-main banner-overlay">
            <a href="category.html">
              <img src="asset/images/demos/demo-16/banners/banner-1.jpg" alt="Banner" />
            </a>
            <div className="banner-content left">
              <div className="banner-title"><a href="#">Dresses for all occasions.</a></div>{/* End .banner-title */}
              <p>Nail your on and off duty style with our new season collection of women’s dresses.</p>
              <a href="#" className="banner-link">Discover Now <i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-main */}
          </div>{/* End .banner banner-overlay */}
        </div>{/* End .col-lg-6 */}
        <div className="col-sm-4 col-lg-3 order-lg-first">
          <div className="display-products-col">
            <div className="product product-4 mb-7">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-16/products/product-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-16/products/product-1-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Black ruched side slip dress</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $76.00
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .display-products-col */}
        </div>{/* End .col-sm-6 col-lg-3 */}
        <div className="col-sm-8 col-lg-3">
          <div className="display-products-col">
            <div className="row">
              <div className="col-6 col-lg-12">
                <div className="product product-4 mb-7">
                  <figure className="product-media">
                    <a href="product.html">
                      <img src="asset/images/demos/demo-16/products/product-2.jpg" alt="Product image" className="product-image" />
                      <img src="asset/images/demos/demo-16/products/product-2-2.jpg" alt="Product image" className="product-image-hover" />
                    </a>
                    <div className="product-action-vertical">
                      <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                      <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                    </div>{/* End .product-action */}
                    <div className="product-action">
                      <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    </div>{/* End .product-action */}
                  </figure>{/* End .product-media */}
                  <div className="product-body">
                    <h3 className="product-title"><a href="product.html">Dark brown belted shirt dress</a></h3>{/* End .product-title */}
                    <div className="product-price">
                      $100.00
                    </div>{/* End .product-price */}
                  </div>{/* End .product-body */}
                </div>{/* End .product */}
              </div>{/* End .col-sm-6 col-lg-12 */}
              <div className="col-6 col-lg-12">
                <div className="product product-4 mb-7">
                  <figure className="product-media">
                    <a href="product.html">
                      <img src="asset/images/demos/demo-16/products/product-3.jpg" alt="Product image" className="product-image" />
                      <img src="asset/images/demos/demo-16/products/product-3-2.jpg" alt="Product image" className="product-image-hover" />
                    </a>
                    <div className="product-action-vertical">
                      <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                      <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                    </div>{/* End .product-action */}
                    <div className="product-action">
                      <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    </div>{/* End .product-action */}
                  </figure>{/* End .product-media */}
                  <div className="product-body">
                    <h3 className="product-title"><a href="product.html">Blue belted midi denim dress</a></h3>{/* End .product-title */}
                    <div className="product-price">
                      $110.00
                    </div>{/* End .product-price */}
                  </div>{/* End .product-body */}
                </div>{/* End .product */}
              </div>{/* End .col-sm-6 col-lg-12 */}
            </div>{/* End .row */}
          </div>{/* End .display-products-col */}
        </div>{/* End .col-sm-6 col-lg-3 */}
      </div>{/* End .row */}
      <div className="row">
        <div className="col-lg-6">
          <div className="banner banner-main banner-main-reverse banner-overlay">
            <a href="category.html">
              <img src="asset/images/demos/demo-16/banners/banner-2.jpg" alt="Banner" />
            </a>
            <div className="banner-content right">
              <div className="banner-title"><a href="#">Coats &amp; Jackets for effortless everyday looks.</a></div>{/* End .banner-title */}
              <p>Whichever style you choose from our new season collection of women’s coats and jackets, cosy chic vibes are guaranteed.</p>
              <a href="#" className="banner-link">Discover Now <i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-main */}
          </div>{/* End .banner banner-overlay */}
        </div>{/* End .col-lg-6 */}
        <div className="col-sm-8 col-lg-3 order-lg-first">
          <div className="display-products-col">
            <div className="row">
              <div className="col-6 col-lg-12">
                <div className="product product-4">
                  <figure className="product-media">
                    <a href="product.html">
                      <img src="asset/images/demos/demo-16/products/product-4.jpg" alt="Product image" className="product-image" />
                      <img src="asset/images/demos/demo-16/products/product-4-2.jpg" alt="Product image" className="product-image-hover" />
                    </a>
                    <div className="product-action-vertical">
                      <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                      <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                    </div>{/* End .product-action */}
                    <div className="product-action">
                      <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    </div>{/* End .product-action */}
                  </figure>{/* End .product-media */}
                  <div className="product-body">
                    <h3 className="product-title"><a href="product.html">Dark yellow cropped denim jacket</a></h3>{/* End .product-title */}
                    <div className="product-price">
                      $96.00
                    </div>{/* End .product-price */}
                  </div>{/* End .product-body */}
                </div>{/* End .product */}
              </div>{/* End .col-sm-6 col-lg-12 */}
              <div className="col-6 col-lg-12">
                <div className="product product-4">
                  <figure className="product-media">
                    <a href="product.html">
                      <img src="asset/images/demos/demo-16/products/product-5.jpg" alt="Product image" className="product-image" />
                      <img src="asset/images/demos/demo-16/products/product-5-2.jpg" alt="Product image" className="product-image-hover" />
                    </a>
                    <div className="product-action-vertical">
                      <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                      <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                    </div>{/* End .product-action */}
                    <div className="product-action">
                      <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    </div>{/* End .product-action */}
                  </figure>{/* End .product-media */}
                  <div className="product-body">
                    <h3 className="product-title"><a href="product.html">Light brown faux suede biker jacket</a></h3>{/* End .product-title */}
                    <div className="product-price">
                      $358.00
                    </div>{/* End .product-price */}
                  </div>{/* End .product-body */}
                </div>{/* End .product */}
              </div>{/* End .col-sm-6 col-lg-12 */}
            </div>{/* End .row */}
          </div>{/* End .display-products-col */}
        </div>{/* End .col-sm-6 col-lg-3 */}
        <div className="col-sm-4 col-lg-3">
          <div className="display-products-col">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-16/products/product-6.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-16/products/product-6-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Light brown check suedette <br />trench coat</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $170.00
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .display-products-col */}
        </div>{/* End .col-sm-6 col-lg-3 */}
      </div>{/* End .row */}
    </div>{/* End .products-display */}
  </div>{/* End .container */}
  <div className="bg-lighter pt-6 pb-9">
    <div className="container">
      <div className="heading text-center">
        <h2 className="title">Shop The Collection</h2>{/* End .title */}
        <p className="title-desc">Donec nec justo eget felis facilisis fermentum. <br />Aliquam porttitor mauris sit amet orci..</p>{/* End .title-desc */}
      </div>{/* End .heading */}
      <div className="owl-carousel owl-simple" data-toggle="owl" data-owl-options="{
          &quot;nav&quot;: false, 
          &quot;dots&quot;: true,
          &quot;margin&quot;: 20,
          &quot;loop&quot;: false,
          &quot;responsive&quot;: {
              &quot;0&quot;: {
                  &quot;items&quot;:2
              },
              &quot;480&quot;: {
                  &quot;items&quot;:2
              },
              &quot;768&quot;: {
                  &quot;items&quot;:3
              },
              &quot;992&quot;: {
                  &quot;items&quot;:4
              },
              &quot;1200&quot;: {
                  &quot;items&quot;:4,
                  &quot;nav&quot;: true,
                  &quot;dots&quot;: false
              }
          }
      }">
        <div className="product product-4">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-16/products/product-7.jpg" alt="Product image" className="product-image" />
              <img src="asset/images/demos/demo-16/products/product-7-2.jpg" alt="Product image" className="product-image-hover" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
              <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
              <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Clothing</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">Linen-blend dress</a></h3>{/* End .product-title */}
            <div className="product-price">
              $60.00
            </div>{/* End .product-price */}
            <div className="product-nav product-nav-dots">
              <a href="#" className="active" style={{background: '#e5dcb1'}}><span className="sr-only">Color name</span></a>
              <a href="#" style={{background: '#bacbd8'}}><span className="sr-only">Color name</span></a>
            </div>{/* End .product-nav */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
        <div className="product product-4">
          <figure className="product-media">
            <span className="product-label label-primary">Sale</span>
            <a href="product.html">
              <img src="asset/images/demos/demo-16/products/product-8.jpg" alt="Product image" className="product-image" />
              <img src="asset/images/demos/demo-16/products/product-8-2.jpg" alt="Product image" className="product-image-hover" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
              <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
              <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Shoes</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">Sandals with lacing</a></h3>{/* End .product-title */}
            <div className="product-price">
              <span className="new-price">Now $70.00</span>
              <span className="old-price">Was $155.00</span>
            </div>{/* End .product-price */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
        <div className="product product-4">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-16/products/product-9.jpg" alt="Product image" className="product-image" />
              <img src="asset/images/demos/demo-16/products/product-9-2.jpg" alt="Product image" className="product-image-hover" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
              <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
              <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Clothing</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">Paper bag trousers</a></h3>{/* End .product-title */}
            <div className="product-price">
              $58.00
            </div>{/* End .product-price */}
            <div className="product-nav product-nav-dots">
              <a href="#" className="active" style={{background: '#9fac76'}}><span className="sr-only">Color name</span></a>
              <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
            </div>{/* End .product-nav */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
        <div className="product product-4">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-16/products/product-10.jpg" alt="Product image" className="product-image" />
              <img src="asset/images/demos/demo-16/products/product-10-2.jpg" alt="Product image" className="product-image-hover" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
              <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
              <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Handbags</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">Paper straw shopper</a></h3>{/* End .product-title */}
            <div className="product-price">
              $398.00
            </div>{/* End .product-price */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
        <div className="product product-4">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-16/products/product-6.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
              <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
              <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Clothing</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">Gray-blend dress</a></h3>{/* End .product-title */}
            <div className="product-price">
              $85.00
            </div>{/* End .product-price */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
      </div>{/* End .owl-carousel owl-simple */}
    </div>{/* End .container */}
  </div>{/* End .bg-lighter pt-5 pb-5 */}
  <div className="video-banner video-banner-bg bg-image text-center" style={{backgroundImage: 'url(asset/images/demos/demo-16/bg-1.jpg)'}}>
    <div className="container">
      <h3 className="video-banner-title h1 text-white"><span>Spring / Summer</span><strong>New &amp; Stylish</strong><br /> Collection 2019</h3>{/* End .video-banner-title */}
      <a href="https://www.youtube.com/watch?v=vBPgmASQ1A0" className="btn-video btn-iframe"><i className="icon-play" /></a>
    </div>{/* End .container */}
  </div>{/* End .video-banner bg-image */}
  <div className="mb-6" />{/* End .mb-6 */}
  <div className="blog-posts">
    <div className="container">
      <div className="heading text-center">
        <h2 className="title">New Blog Posts</h2>{/* End .title */}
        <p className="title-desc">Donec nec justo eget felis facilisis fermentum.</p>{/* End .title-desc */}
      </div>{/* End .heading */}
      <div className="owl-carousel owl-simple mb-4" data-toggle="owl" data-owl-options="{
          &quot;nav&quot;: false, 
          &quot;dots&quot;: true,
          &quot;items&quot;: 3,
          &quot;margin&quot;: 20,
          &quot;loop&quot;: false,
          &quot;responsive&quot;: {
              &quot;0&quot;: {
                  &quot;items&quot;:1
              },
              &quot;600&quot;: {
                  &quot;items&quot;:2
              },
              &quot;992&quot;: {
                  &quot;items&quot;:3
              },
              &quot;1200&quot;: {
                  &quot;items&quot;:3,
                  &quot;nav&quot;: true,
                  &quot;dots&quot;: false
              }
          }
      }">
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-16/blog/post-1.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Nov 22, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Sed adipiscing ornare.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-16/blog/post-2.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Dec 12, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Aenean dignissim pellentesque felis.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-16/blog/post-3.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Dec 19, 2018</a>, 2 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Quisque volutpat mattis eros.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-2/blog/post-2.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Dec 12, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Aenean dignissim pellentesque felis.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
      </div>{/* End .owl-carousel */}
      <div className="more-container text-center">
        <a href="blog.html" className="btn btn-outline-primary-2 btn-more"><span>View more articles</span><i className="icon-long-arrow-right" /></a>
      </div>{/* End .more-container */}
      <hr className="mb-3" />
    </div>{/* End .container */}
  </div>{/* End .blog-posts */}
  <div className="cta-newsletter text-center pt-4 pb-7">
    <div className="container">
      <span className="cta-icon"><i className="icon-envelope" /></span>
      <h3 className="title">Subscribe for Our Newsletter</h3>{/* End .title */}
      <p className="title-desc">and receive <span className="text-primary">$20 coupon</span> for first shopping</p>{/* End .title-desc */}
      <form action="#">
        <div className="input-group">
          <input type="email" className="form-control" placeholder="Enter your Email Address" aria-label="Email Adress" aria-describedby="newsletter-btn" required />
          <div className="input-group-append">
            <button className="btn btn-dark" type="submit" id="newsletter-btn"><span>SUBSCRIBE</span><i className="icon-long-arrow-right" /></button>
          </div>{/* .End .input-group-append */}
        </div>{/* .End .input-group */}
      </form>
      <p className="newsletter-desc">Your personal details are safe with us.</p>{/* End .newsletter-desc */}
    </div>{/* End .container */}
  </div>{/* End .cta-newsletter */}
  <div className="bg-lighter instagram pb-5">
    <div className="container">
      <h2 className="title text-center mb-3 mb-md-4">Let Us Inspire You On Instagram</h2>{/* End .title */}
      <div className="owl-carousel owl-simple" data-toggle="owl" data-owl-options="{
          &quot;nav&quot;: false, 
          &quot;dots&quot;: false,
          &quot;items&quot;: 5,
          &quot;margin&quot;: 20,
          &quot;loop&quot;: false,
          &quot;responsive&quot;: {
              &quot;0&quot;: {
                  &quot;items&quot;:1
              },
              &quot;360&quot;: {
                  &quot;items&quot;:2
              },
              &quot;600&quot;: {
                  &quot;items&quot;:3
              },
              &quot;992&quot;: {
                  &quot;items&quot;:4
              },
              &quot;1200&quot;: {
                  &quot;items&quot;:5
              }
          }
      }">
        <div className="instagram-feed">
          <img src="asset/images/demos/demo-16/instagram/1.jpg" alt="img" />
          <div className="instagram-feed-content">
            <a href="#"><i className="icon-heart-o" />466</a>
            <a href="#"><i className="icon-comments" />65</a>
          </div>{/* End .instagram-feed-content */}
        </div>{/* End .instagram-feed */}
        <div className="instagram-feed">
          <img src="asset/images/demos/demo-16/instagram/2.jpg" alt="img" />
          <div className="instagram-feed-content">
            <a href="#"><i className="icon-heart-o" />39</a>
            <a href="#"><i className="icon-comments" />78</a>
          </div>{/* End .instagram-feed-content */}
        </div>{/* End .instagram-feed */}
        <div className="instagram-feed">
          <img src="asset/images/demos/demo-16/instagram/3.jpg" alt="img" />
          <div className="instagram-feed-content">
            <a href="#"><i className="icon-heart-o" />691</a>
            <a href="#"><i className="icon-comments" />87</a>
          </div>{/* End .instagram-feed-content */}
        </div>{/* End .instagram-feed */}
        <div className="instagram-feed">
          <img src="asset/images/demos/demo-16/instagram/4.jpg" alt="img" />
          <div className="instagram-feed-content">
            <a href="#"><i className="icon-heart-o" />508</a>
            <a href="#"><i className="icon-comments" />124</a>
          </div>{/* End .instagram-feed-content */}
        </div>{/* End .instagram-feed */}
        <div className="instagram-feed">
          <img src="asset/images/demos/demo-16/instagram/5.jpg" alt="img" />
          <div className="instagram-feed-content">
            <a href="#"><i className="icon-heart-o" />433</a>
            <a href="#"><i className="icon-comments" />27</a>
          </div>{/* End .instagram-feed-content */}
        </div>{/* End .instagram-feed */}
      </div>{/* End .owl-carousel */}
    </div>{/* End .container */}
  </div>{/* End .bg-lighter pt-5 */}
</main>

        <UserFooter/>
    </div>
  )
}

export default Index16